import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ShieldAlert, ArrowRight } from "lucide-react";
import { CLOSED_COMPLAINT, DaysOpenBadge } from "@/pages/Complaints";

const daysOpen = (c) => Math.floor((Date.now() - new Date(c.created_at)) / 86400000);

export const StaleComplaints = () => {
  const [list, setList] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/complaints").then((r) => setList((r.data || []).filter((c) => c.created_at && !CLOSED_COMPLAINT.includes(c.status) && daysOpen(c) > 14).sort((a, b) => daysOpen(b) - daysOpen(a)))).catch(() => {});
  }, []);
  if (list.length === 0) return null;
  return (
    <div className="bg-white rounded-xl border border-red-200 p-5" data-testid="dashboard-stale-complaints">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-heading font-semibold text-slate-800 flex items-center gap-2"><ShieldAlert className="h-5 w-5 text-red-600" /> Klachten langer dan 14 dagen open <span className="text-sm font-normal text-red-600">({list.length})</span></h2>
        <button className="text-sm text-[#0F1E3D] font-medium hover:text-[#C9A227] hover:underline flex items-center gap-1" onClick={() => navigate("/app/klachten")} data-testid="dashboard-stale-complaints-all">Alle klachten <ArrowRight className="h-3.5 w-3.5" /></button>
      </div>
      <div className="divide-y">
        {list.slice(0, 8).map((c) => (
          <button key={c.id} type="button" onClick={() => navigate(c.tenant_id ? `/app/huurders/${c.tenant_id}` : "/app/klachten")} className="w-full flex items-center justify-between gap-3 py-2.5 text-left hover:bg-slate-50 px-2 rounded-lg" data-testid={`stale-complaint-${c.id}`}>
            <div className="min-w-0">
              <div className="text-sm font-medium text-slate-800 truncate">{c.number && <span className="text-slate-400 font-normal mr-1">{c.number}</span>}{c.title}</div>
              <div className="text-xs text-slate-500 truncate">{c.tenant_name || "—"}</div>
            </div>
            <DaysOpenBadge c={c} />
          </button>
        ))}
      </div>
    </div>
  );
};
